module.exports = __webpack_public_path__ + "img/download.a2b93b03.png";